import React, { useContext, useEffect, useState } from 'react';
import { Grid, Paper, Typography } from '@mui/material';
import { ThemeContext } from "../../context/ThemeContext";

const KPIComponent = ({ data }) => {
    const [kpis, setKPIs] = useState([]);

    const { isDarkMode } = useContext(ThemeContext);

    const colors = !isDarkMode ? ["#C2000F", "#5D8F15"] : ["#F95E64", "#62A575"];
    const textColor = !isDarkMode ? 'white' : 'black';

    useEffect(() => {
        // Update KPIs whenever data changes
        setKPIs([
            { title: 'Total Monthly Tickets', value: data?.total_monthly_tickets || 'N/A', trend: '↑ 15%' },
            { title: 'Total Closed Tickets', value: data?.total_closed_tickets || 'N/A', trend: '↓ 5%' },
            { title: 'Incoming/Closed Ratio', value: data?.incoming_closed_ratio+"%" || 'N/A', trend: '↓ 1%' },
        ]);
        console.log(data)
    }, [data]);

    return (
        <Grid container spacing={3}>
            {kpis.map((kpi, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                    <Paper
                        elevation={12}
                        sx={{
                            padding: 2,
                            textAlign: 'center',
                            color: textColor,
                            backgroundColor: kpi.trend.includes('↑') ? colors[1] : colors[0],
                        }}
                    >
                        <Typography variant="h6" gutterBottom>
                            {kpi.title}
                        </Typography>
                        <Typography variant="h4" fontWeight="bold" gutterBottom>
                            {kpi.value}
                        </Typography>
                        <Typography
                            variant="subtitle1"
                            sx={{
                                fontWeight: 'bold',
                            }}
                        >
                            {kpi.trend}
                        </Typography>
                    </Paper>
                </Grid>
            ))}
        </Grid>
    );
};

export default KPIComponent;
